import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { getErrorText } from '@common/utils';
import { I18NextPipe } from 'angular-i18next';

@Injectable({ providedIn: 'root' })
export class ModalUtilsService {
  private readonly i18nPipe = inject(I18NextPipe);

  async handleBeforeSave(request: Promise<any>, onSuccess: () => void, onError: (errorMessage: string) => void): Promise<void> {
    const fallbackError = this.i18nPipe.transform('common.validation.somethingWrong', { format: 'capitalize' });

    const res = await request.catch((err: HttpErrorResponse) => ({
      resolve: false,
      error: getErrorText(err) || fallbackError
    }));

    const { resolve, error = null } =
      res instanceof HttpResponse && res.status === 200 && res.body === null
        ? { resolve: true }
        : (res ?? { resolve: false, error: fallbackError });

    if (resolve) {
      onSuccess();
    } else {
      onError(error);
    }
  }
}
